import { useEffect, useRef, useState } from 'react';

// Phone: a bar that stays pinned just UNDER the phone's own status bar (clock, camera cut-out,
// battery …) while the page scrolls. The safe-area height is measured from the device, so it
// fits every phone brand and size. `is-stuck` is set once the bar has reached the top, which
// lets the CSS paint a cover strip behind the status bar.
export const StickyBar = ({ className, children }) => {
  const sentinel = useRef(null);
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    const el = sentinel.current;
    if (!el || typeof IntersectionObserver === 'undefined') return undefined;
    let io = null;
    const connect = () => {
      if (io) io.disconnect();
      const probe = document.createElement('div');
      probe.style.cssText = 'position:fixed;top:0;left:0;width:0;height:var(--sat);visibility:hidden;pointer-events:none';
      document.body.appendChild(probe);
      const sat = probe.offsetHeight || 0;
      document.body.removeChild(probe);
      io = new IntersectionObserver(([e]) => {
        setStuck(!e.isIntersecting && e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.top : 0));
      }, { root: el.closest('.m-content'), rootMargin: `-${sat}px 0px 0px 0px`, threshold: [0, 1] });
      io.observe(el);
    };
    connect();
    window.addEventListener('resize', connect);
    return () => { if (io) io.disconnect(); window.removeEventListener('resize', connect); };
  }, []);
  return (
    <>
      <div ref={sentinel} className="m-sentinel" />
      <div className={`${className}${stuck ? ' is-stuck' : ''}`}>{children}</div>
    </>
  );
};
